import { BaseModule } from './BaseModule';
import { ServiceNowAdapterEvent } from '../enums';
import { ModuleBaseOption } from '../interfaces/module';

class DialModule extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromSN();
        }
    }
    private listenFromSN() {
        this.mServiceNowAdapter!.on(ServiceNowAdapterEvent.CLICK_TO_DIAL, (data) => {
            this.mRCXAdapter!.dialToCall(data?.[0]?.data?.metaData?.phoneNumber);
            this.mServiceNowAdapter!.showOpenFrame();
        });
    }
}

export default new DialModule();
